import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { TextMaskModule } from 'angular2-text-mask';
import { Ng5SliderModule } from 'ng5-slider';

import { SelectComponent } from './select/select.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ModalComponent } from './modal/modal.component';
import { LoadingAnimationComponent } from './loading-animation/loading-animation.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { StyledSpreadComponent } from './styled-spread/styled-spread.component';
import { PhotoGridComponent } from './photo-grid/photo-grid.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { ZoomButtonComponent } from './zoom-button/zoom-button.component';
import { ButtonComponent } from './button/button.component';
import { ActivatePromocodeLinkComponent } from './activate-promocode-link/activate-promocode-link.component';
import { PromocodeModalComponent } from './promocode-modal/promocode-modal.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { PriceTextComponent } from './price-text/price-text.component';
import { CompactUploadModalComponent } from '../+stories/uploadProgress/compact-upload-modal/compactUploadModal.component';
import { SliderComponent } from './slider/slider.component';
import { AppStoreButtonComponent } from './app-store-button/app-store-button.component';
import { GooglePlayButtonComponent } from './google-play-button/google-play-button.component';
import { CompactUploadProgressComponent } from '../+stories/uploadProgress/compact-upload-progress/compactUploadProgress.component';
import { UploadProgressComponent } from '../+stories/uploadProgress/uploadProgress.component';
import { HiresWarningMeassageComponent } from '../+stories/list/upload-completed/hires-warning-meassage.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { AppLinkButtonComponent } from '../+landing/landing-shared/start-button/app-link-button.component';

import { DeferLoadDirective } from './defer-load.directive';
import { AdjustableTextareaDirective } from './adjustable-textarea.directive';
import { MouseWheelDirective } from './mousewheel.directive';
import { ImageProgressComponent } from './photo-grid/progress/progress.component';
import { ShoppingLocationModalComponent } from './shopping-location-modal/shopping-location-modal.component';
import { ProfileService } from 'app/+profile/profile.service';

const COMPONENTS = [
  SelectComponent,
  DropdownComponent,
  LoadingAnimationComponent,
  ImageViewerComponent,
  PhoneInputComponent,
  ModalComponent,
  MouseWheelDirective,
  TooltipComponent,
  StyledSpreadComponent,
  PhotoGridComponent,
  AdjustableTextareaDirective,
  ZoomButtonComponent,
  ButtonComponent,
  ActivatePromocodeLinkComponent,
  PromocodeModalComponent,
  PromotionsComponent,
  PriceTextComponent,
  CompactUploadModalComponent,
  SliderComponent,
  AppStoreButtonComponent,
  GooglePlayButtonComponent,
  CompactUploadProgressComponent,
  UploadProgressComponent,
  DeferLoadDirective,
  HiresWarningMeassageComponent,
  DownloadAppComponent,
  AppLinkButtonComponent,
  ImageProgressComponent,
  ShoppingLocationModalComponent,
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TextMaskModule,
    PortalModule,
    TranslateModule,
    Ng5SliderModule,
    RouterModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [ProfileService],
})
export class SharedModule {}
